import { useMemo } from 'react';
import useHotelCommunicationSettings from './useHotelCommunicationSettings';
import {
  isBookingCreatedGuestNotifyEnabled,
  isCommEventEnabled,
} from '../services/api';

const PAYMENT_LINK_METHOD = 'PAYMENT LINK';

/** Communication flags for Razorpay payment-link send UI (gated on booking-created guest notifications). */
export function useBookingPaymentLinkComm() {
  const { commSettings, loading } = useHotelCommunicationSettings();

  const canSendPaymentLink = useMemo(
    () => isBookingCreatedGuestNotifyEnabled(commSettings),
    [commSettings]
  );
  const canSendPaymentLinkEmail = useMemo(
    () => isCommEventEnabled(commSettings, 'booking_created', 'email'),
    [commSettings]
  );
  const canSendPaymentLinkWhatsApp = useMemo(
    () => isCommEventEnabled(commSettings, 'booking_created', 'whatsapp'),
    [commSettings]
  );

  return {
    commSettings,
    loading,
    canSendPaymentLink,
    canSendPaymentLinkEmail,
    canSendPaymentLinkWhatsApp,
  };
}

/** Drop PAYMENT LINK from method chips when booking-created notifications are off. */
export function filterPaymentMethodsForComm(methods, canSendPaymentLink) {
  if (canSendPaymentLink) return methods;
  return methods.filter((m) => m !== PAYMENT_LINK_METHOD);
}

export { PAYMENT_LINK_METHOD };
